import { Spacer } from "@faire/web/slate/spacing";
import React from "react";
import { SWFBlurb } from "../components/SWFBlurb";
import { useLoggedOutBrandNodes } from "../hooks/useLoggedOutBrandNodes";
export var Blurb = function Blurb(_ref) {
  var issueL3 = _ref.issueL3,
    loggedOutExperience = _ref.loggedOutExperience;
  var brandNodes = useLoggedOutBrandNodes();
  if (issueL3 === brandNodes.L3.Availability && !loggedOutExperience) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SWFBlurb, null), /*#__PURE__*/React.createElement(Spacer, {
      height: "2x"
    }));
  }
  return null;
};